import { render, staticRenderFns } from "./BfBalanceQkAudit.vue?vue&type=template&id=bc98f0a0&scoped=true"
import script from "./BfBalanceQkAudit.vue?vue&type=script&lang=js"
export * from "./BfBalanceQkAudit.vue?vue&type=script&lang=js"
import style0 from "./BfBalanceQkAudit.vue?vue&type=style&index=0&id=bc98f0a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc98f0a0",
  null
  
)

export default component.exports